"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAIN = void 0;
var CHAIN;
(function (CHAIN) {
    CHAIN["MAINNET"] = "-239";
})(CHAIN || (exports.CHAIN = CHAIN = {}));
